/* eslint-disable react/prop-types */
import React from 'react';

export const XLcompleted = ({ width = '80', height = '80' }) => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
      <path
        d="M0 0 C6.6 0 13.2 0 20 0 C20 1.65 20 3.3 20 5 C23.3 5 26.6 5 30 5 C30 6.65 30 8.3 30 10 C31.65 10 33.3 10 35 10 C35 11.65 35 13.3 35 15 C36.65 15 38.3 15 40 15 C40 16.65 40 18.3 40 20 C41.65 20 43.3 20 45 20 C45 23.3 45 26.6 45 30 C46.65 30 48.3 30 50 30 C50 36.6 50 43.2 50 50 C48.35 50 46.7 50 45 50 C45 53.3 45 56.6 45 60 C43.35 60 41.7 60 40 60 C40 61.65 40 63.3 40 65 C38.35 65 36.7 65 35 65 C35 66.65 35 68.3 35 70 C33.35 70 31.7 70 30 70 C30 71.65 30 73.3 30 75 C26.7 75 23.4 75 20 75 C20 76.65 20 78.3 20 80 C13.4 80 6.8 80 0 80 C0 78.35 0 76.7 0 75 C-3.3 75 -6.6 75 -10 75 C-10 73.35 -10 71.7 -10 70 C-11.65 70 -13.3 70 -15 70 C-15 68.35 -15 66.7 -15 65 C-16.65 65 -18.3 65 -20 65 C-20 63.35 -20 61.7 -20 60 C-21.65 60 -23.3 60 -25 60 C-25 56.7 -25 53.4 -25 50 C-26.65 50 -28.3 50 -30 50 C-30 43.4 -30 36.8 -30 30 C-28.35 30 -26.7 30 -25 30 C-25 26.7 -25 23.4 -25 20 C-23.35 20 -21.7 20 -20 20 C-20 18.35 -20 16.7 -20 15 C-18.35 15 -16.7 15 -15 15 C-15 13.35 -15 11.7 -15 10 C-13.35 10 -11.7 10 -10 10 C-10 8.35 -10 6.7 -10 5 C-6.7 5 -3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#9A6808"
        transform="translate(30,0)"
      />
      <path
        d="M0 0 C6.6 0 13.2 0 20 0 C20 1.65 20 3.3 20 5 C23.3 5 26.6 5 30 5 C30 9.95 30 14.9 30 20 C26.7 20 23.4 20 20 20 C20 21.65 20 23.3 20 25 C21.65 25 23.3 25 25 25 C25 26.65 25 28.3 25 30 C21.7 30 18.4 30 15 30 C15 28.35 15 26.7 15 25 C11.7 25 8.4 25 5 25 C5 26.65 5 28.3 5 30 C3.35 30 1.7 30 0 30 C0 36.6 0 43.2 0 50 C1.65 50 3.3 50 5 50 C5 51.65 5 53.3 5 55 C8.3 55 11.6 55 15 55 C15 53.35 15 51.7 15 50 C18.3 50 21.6 50 25 50 C25 51.65 25 53.3 25 55 C23.35 55 21.7 55 20 55 C20 56.65 20 58.3 20 60 C13.4 60 6.8 60 0 60 C0 58.35 0 56.7 0 55 C-1.65 55 -3.3 55 -5 55 C-5 53.35 -5 51.7 -5 50 C-6.65 50 -8.3 50 -10 50 C-10 43.4 -10 36.8 -10 30 C-8.35 30 -6.7 30 -5 30 C-5 28.35 -5 26.7 -5 25 C-3.35 25 -1.7 25 0 25 C0 23.35 0 21.7 0 20 C-3.3 20 -6.6 20 -10 20 C-10 15.05 -10 10.1 -10 5 C-6.7 5 -3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#CFAC69"
        transform="translate(30,0)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C6.65 5 8.3 5 10 5 C10 6.65 10 8.3 10 10 C11.65 10 13.3 10 15 10 C15 13.3 15 16.6 15 20 C13.35 20 11.7 20 10 20 C10 26.6 10 33.2 10 40 C6.7 40 3.4 40 0 40 C0 38.35 0 36.7 0 35 C-1.65 35 -3.3 35 -5 35 C-5 36.65 -5 38.3 -5 40 C-8.3 40 -11.6 40 -15 40 C-15 41.65 -15 43.3 -15 45 C-18.3 45 -21.6 45 -25 45 C-25 43.35 -25 41.7 -25 40 C-26.65 40 -28.3 40 -30 40 C-30 33.4 -30 26.8 -30 20 C-28.35 20 -26.7 20 -25 20 C-25 18.35 -25 16.7 -25 15 C-21.7 15 -18.4 15 -15 15 C-15 16.65 -15 18.3 -15 20 C-11.7 20 -8.4 20 -5 20 C-5 18.35 -5 16.7 -5 15 C-6.65 15 -8.3 15 -10 15 C-10 13.35 -10 11.7 -10 10 C-6.7 10 -3.4 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#FEC416"
        transform="translate(60,10)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C8.3 10 11.6 10 15 10 C15 11.65 15 13.3 15 15 C13.35 15 11.7 15 10 15 C10 16.65 10 18.3 10 20 C8.35 20 6.7 20 5 20 C5 26.6 5 33.2 5 40 C6.65 40 8.3 40 10 40 C10 41.65 10 43.3 10 45 C11.65 45 13.3 45 15 45 C15 46.65 15 48.3 15 50 C13.35 50 11.7 50 10 50 C10 51.65 10 53.3 10 55 C8.35 55 6.7 55 5 55 C5 53.35 5 51.7 5 50 C0.05 50 -4.9 50 -10 50 C-10 46.7 -10 43.4 -10 40 C-11.65 40 -13.3 40 -15 40 C-15 33.4 -15 26.8 -15 20 C-13.35 20 -11.7 20 -10 20 C-10 16.7 -10 13.4 -10 10 C-8.35 10 -6.7 10 -5 10 C-5 8.35 -5 6.7 -5 5 C-3.35 5 -1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#F0DFB7"
        transform="translate(15,10)"
      />
      <path
        d="M0 0 C6.6 0 13.2 0 20 0 C20 1.65 20 3.3 20 5 C21.65 5 23.3 5 25 5 C25 6.65 25 8.3 25 10 C21.7 10 18.4 10 15 10 C15 8.35 15 6.7 15 5 C11.7 5 8.4 5 5 5 C5 6.65 5 8.3 5 10 C3.35 10 1.7 10 0 10 C0 16.6 0 23.2 0 30 C1.65 30 3.3 30 5 30 C5 31.65 5 33.3 5 35 C8.3 35 11.6 35 15 35 C15 33.35 15 31.7 15 30 C18.3 30 21.6 30 25 30 C25 31.65 25 33.3 25 35 C23.35 35 21.7 35 20 35 C20 36.65 20 38.3 20 40 C13.4 40 6.8 40 0 40 C0 38.35 0 36.7 0 35 C-1.65 35 -3.3 35 -5 35 C-5 33.35 -5 31.7 -5 30 C-6.65 30 -8.3 30 -10 30 C-10 23.4 -10 16.8 -10 10 C-8.35 10 -6.7 10 -5 10 C-5 8.35 -5 6.7 -5 5 C-3.35 5 -1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFFFFF"
        transform="translate(30,20)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C18.25 5 26.5 5 35 5 C35 6.65 35 8.3 35 10 C36.65 10 38.3 10 40 10 C40 13.3 40 16.6 40 20 C33.4 20 26.8 20 20 20 C20 18.35 20 16.7 20 15 C16.7 15 13.4 15 10 15 C10 13.35 10 11.7 10 10 C8.35 10 6.7 10 5 10 C5 8.35 5 6.7 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#BB9010"
        transform="translate(10,60)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 4.95 10 9.9 10 15 C1.75 15 -6.5 15 -15 15 C-15 18.3 -15 21.6 -15 25 C-13.35 25 -11.7 25 -10 25 C-10 26.65 -10 28.3 -10 30 C-8.35 30 -6.7 30 -5 30 C-5 31.65 -5 33.3 -5 35 C-8.3 35 -11.6 35 -15 35 C-15 33.35 -15 31.7 -15 30 C-16.65 30 -18.3 30 -20 30 C-20 23.4 -20 16.8 -20 10 C-18.35 10 -16.7 10 -15 10 C-15 8.35 -15 6.7 -15 5 C-11.7 5 -8.4 5 -5 5 C-5 6.65 -5 8.3 -5 10 C-1.7 10 1.6 10 5 10 C5 8.35 5 6.7 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#A97309"
        transform="translate(50,20)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C8.35 5 6.7 5 5 5 C5 11.6 5 18.2 5 25 C6.65 25 8.3 25 10 25 C10 26.65 10 28.3 10 30 C11.65 30 13.3 30 15 30 C15 31.65 15 33.3 15 35 C13.35 35 11.7 35 10 35 C10 36.65 10 38.3 10 40 C8.35 40 6.7 40 5 40 C5 38.35 5 36.7 5 35 C3.35 35 1.7 35 0 35 C0 31.7 0 28.4 0 25 C-1.65 25 -3.3 25 -5 25 C-5 21.7 -5 18.4 -5 15 C-3.35 15 -1.7 15 0 15 C0 10.05 0 5.1 0 0 Z "
        fill="#C0923A"
        transform="translate(15,25)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 6.6 10 13.2 10 20 C8.35 20 6.7 20 5 20 C5 23.3 5 26.6 5 30 C1.7 30 -1.6 30 -5 30 C-5 26.7 -5 23.4 -5 20 C-3.35 20 -1.7 20 0 20 C0 13.4 0 6.8 0 0 Z "
        fill="#D4CFC1"
        transform="translate(70,30)"
      />
      <path
        d="M0 0 C6.6 0 13.2 0 20 0 C20 1.65 20 3.3 20 5 C23.3 5 26.6 5 30 5 C30 6.65 30 8.3 30 10 C16.8 10 3.6 10 -10 10 C-10 8.35 -10 6.7 -10 5 C-6.7 5 -3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFF7DF"
        transform="translate(30,0)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C6.65 5 8.3 5 10 5 C10 8.3 10 11.6 10 15 C11.65 15 13.3 15 15 15 C15 16.65 15 18.3 15 20 C13.35 20 11.7 20 10 20 C10 21.65 10 23.3 10 25 C8.35 25 6.7 25 5 25 C5 23.35 5 21.7 5 20 C3.35 20 1.7 20 0 20 C0 18.35 0 16.7 0 15 C-1.65 15 -3.3 15 -5 15 C-5 13.35 -5 11.7 -5 10 C-3.35 10 -1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#9B6909"
        transform="translate(55,45)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 4.95 10 9.9 10 15 C1.75 15 -6.5 15 -15 15 C-14.67 13.35 -14.34 11.7 -14 10 C-7.73 10 -1.46 10 5 10 C5 8.35 5 6.7 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#9B6909"
        transform="translate(50,20)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C11.65 5 13.3 5 15 5 C15 6.65 15 8.3 15 10 C13.35 10 11.7 10 10 10 C10 11.65 10 13.3 10 15 C8.35 15 6.7 15 5 15 C5 13.35 5 11.7 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#AB740A"
        transform="translate(15,50)"
      />
      <path
        d="M0 0 C6.6 0 13.2 0 20 0 C20 1.65 20 3.3 20 5 C13.4 5 6.8 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#100C02"
        transform="translate(30,75)"
      />
      <path
        d="M0 0 C6.6 0 13.2 0 20 0 C20 1.65 20 3.3 20 5 C13.4 5 6.8 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#D5D0C1"
        transform="translate(30,70)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 3.3 10 6.6 10 10 C6.7 10 3.4 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#CFCBC1"
        transform="translate(65,50)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 6.6 5 13.2 5 20 C3.35 20 1.7 20 0 20 C0 13.4 0 6.8 0 0 Z "
        fill="#4A3B10"
        transform="translate(0,30)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 6.6 5 13.2 5 20 C3.35 20 1.7 20 0 20 C0 13.4 0 6.8 0 0 Z "
        fill="#130E02"
        transform="translate(75,30)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 6.6 5 13.2 5 20 C3.35 20 1.7 20 0 20 C0 13.4 0 6.8 0 0 Z "
        fill="#E0AD13"
        transform="translate(65,30)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 6.6 5 13.2 5 20 C3.35 20 1.7 20 0 20 C0 13.4 0 6.8 0 0 Z "
        fill="#FFCF3C"
        transform="translate(10,20)"
      />
      <path
        d="M0 0 C6.6 0 13.2 0 20 0 C20 1.65 20 3.3 20 5 C13.4 5 6.8 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFD451"
        transform="translate(20,10)"
      />
      <path
        d="M0 0 C6.6 0 13.2 0 20 0 C20 1.65 20 3.3 20 5 C13.4 5 6.8 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#655D42"
        transform="translate(30,0)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 3.3 10 6.6 10 10 C8.35 10 6.7 10 5 10 C5 8.35 5 6.7 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#EBE1C3"
        transform="translate(10,60)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C6.65 5 8.3 5 10 5 C10 6.65 10 8.3 10 10 C6.7 10 3.4 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#A26E09"
        transform="translate(55,45)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C6.65 5 8.3 5 10 5 C10 6.65 10 8.3 10 10 C6.7 10 3.4 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#B1780A"
        transform="translate(35,45)"
      />
      <path
        d="M0 0 C4.95 0 9.9 0 15 0 C15 1.65 15 3.3 15 5 C10.05 5 5.1 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#CFAC69"
        transform="translate(40,45)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C6.65 5 8.3 5 10 5 C10 6.65 10 8.3 10 10 C6.7 10 3.4 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#FFF1C8"
        transform="translate(60,10)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C1.7 10 -1.6 10 -5 10 C-5 8.35 -5 6.7 -5 5 C-3.35 5 -1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFF9E6"
        transform="translate(15,10)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#100C02"
        transform="translate(50,70)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#1B1402"
        transform="translate(20,70)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#D2CEC1"
        transform="translate(50,65)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#E5DDC2"
        transform="translate(20,65)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#F1E6C3"
        transform="translate(10,50)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#352904"
        transform="translate(5,50)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#100C02"
        transform="translate(70,50)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#FFC518"
        transform="translate(10,40)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#FFF1C9"
        transform="translate(5,40)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#1F1803"
        transform="translate(75,30)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#5F5536"
        transform="translate(0,30)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#ECE2C3"
        transform="translate(70,30)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#C49947"
        transform="translate(15,25)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#FFF7E0"
        transform="translate(10,20)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#605944"
        transform="translate(5,20)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#372C07"
        transform="translate(70,20)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#FAEDC4"
        transform="translate(65,20)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#A9720A"
        transform="translate(50,20)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#D5B77C"
        transform="translate(20,15)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFF3CF"
        transform="translate(50,10)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFD146"
        transform="translate(40,10)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFF8E5"
        transform="translate(20,10)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#4F4423"
        transform="translate(50,5)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#645F4F"
        transform="translate(20,5)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#716B59"
        transform="translate(30,0)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#100C02"
        transform="translate(60,65)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#8F6E0C"
        transform="translate(45,65)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#B88E10"
        transform="translate(30,65)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#241C03"
        transform="translate(15,65)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#100C02"
        transform="translate(65,60)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#CFCBC1"
        transform="translate(60,60)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#755A0A"
        transform="translate(55,60)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#C69911"
        transform="translate(20,60)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#2A2104"
        transform="translate(10,60)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#7B5F0B"
        transform="translate(60,55)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#A57009"
        transform="translate(50,55)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#DAA813"
        transform="translate(15,55)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#DBD4C1"
        transform="translate(65,50)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#BE9310"
        transform="translate(60,50)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#B37C12"
        transform="translate(15,50)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FAEDC4"
        transform="translate(10,50)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#A37E0E"
        transform="translate(65,45)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#E4B014"
        transform="translate(60,45)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#B6811A"
        transform="translate(55,45)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#C09138"
        transform="translate(35,45)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#B57F17"
        transform="translate(30,45)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#E0D8C2"
        transform="translate(70,40)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#CB9D12"
        transform="translate(65,40)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#AE760A"
        transform="translate(30,40)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFCA2A"
        transform="translate(10,40)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#534723"
        transform="translate(0,40)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#281F04"
        transform="translate(75,30)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#E9B414"
        transform="translate(65,30)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFD659"
        transform="translate(10,30)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#685F47"
        transform="translate(0,30)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#CBA65D"
        transform="translate(15,25)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#B57F17"
        transform="translate(50,20)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#C49947"
        transform="translate(25,20)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFDD75"
        transform="translate(15,20)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#696350"
        transform="translate(5,20)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#493B0F"
        transform="translate(65,15)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFCB30"
        transform="translate(55,15)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#C89F51"
        transform="translate(50,15)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFDE7A"
        transform="translate(20,15)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#625D4C"
        transform="translate(10,15)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#473912"
        transform="translate(60,10)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFDA6B"
        transform="translate(30,10)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#625C4D"
        transform="translate(15,10)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#6C6758"
        transform="translate(20,5)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#6B634D"
        transform="translate(40,0)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#777162"
        transform="translate(30,0)"
      />
    </svg>
  );
};
